// extracted by mini-css-extract-plugin
module.exports = {"columns":"Columns_columns__1-Zp4","limitWidth":"Columns_limitWidth__4JKBS","limitWidthNarrow":"Columns_limitWidthNarrow__18Q4V","flex":"Columns_flex__TEZLR"};